import { createContext, useContext } from 'react';
import type { Locale } from '@financialharmony/i18n';

export interface LocaleContextValue {
  locale: Locale;
  /** Resolves `false` when the choice could not be saved to the account; the language then stays as it was. */
  setLocale: (next: Locale) => Promise<boolean>;
}

export const LocaleContext = createContext<LocaleContextValue | undefined>(undefined);

export function useUiLocale(): LocaleContextValue {
  const value = useContext(LocaleContext);
  if (!value) throw new Error('useUiLocale must be used inside LocaleProvider');
  return value;
}
